import Batch from '@/page/warehouse/inventory/Batch';
import Goods from '@/page/warehouse/inventory/Goods';
import GoodsAdd from '@/page/warehouse/inventory/GoodsAdd';
import Statement from '@/page/warehouse/inventory/Statement';
import Difference from '@/page/warehouse/inventory/Difference';
import Business from '@/page/warehouse/Business';
import BusinessAdd from '@/page/warehouse/BusinessAdd';
import Query from '@/page/warehouse/Query';
import QueryDetail from '@/page/warehouse/QueryDetail';
import QuerySummary from '@/page/warehouse/QuerySummary';
import QueryInventory from '@/page/warehouse/QueryInventory';
import GoodsDetail from '@/page/warehouse/inventory/GoodsDetail';
import BusinessDetail from '@/page/warehouse/BusinessDetail';
import Adjustment from '@/page/warehouse/purchase/adjustment';
import AdjustmentAdd from '@/page/warehouse/purchase/adjustmentAdd';
import AdjustmentDetail from '@/page/warehouse/purchase/adjustmentDetail';
import purchaseQuery from '@/page/warehouse/purchase/Query';

export const warehouse = [
  {
    path: '/warehouse/inventory/batch',
    name: 'batch',
    component: Batch,
    meta: {
      requireAuth: true,
      title: '盘点批号 - 列表'
    },
  },
  {
    path: '/warehouse/inventory/goods',
    name: 'goods',
    component: Goods,
    meta: {
      requireAuth: true,
      title: '存货盘点单 - 列表'
    },
  },
  {
    path: '/warehouse/inventory/goods/add',
    name: 'goodsAdd',
    component: GoodsAdd,
    meta: {
      requireAuth: true,
      title: '存货盘点单 -  '
    },
  },
  {
    path: '/warehouse/inventory/goods/detail',
    name: 'GoodsDetail',
    component: GoodsDetail,
    meta: {
      requireAuth: true,
      title: '存货盘点单 - 详情'
    },
  },
  {
    path: '/warehouse/inventory/difference',
    name: 'difference',
    component: Difference,
    meta: {
      requireAuth: true,
      title: '盘点差异单'
    },
  },
  {
    path: '/warehouse/business',
    name: 'business',
    component: Business,
    meta: {
      requireAuth: true,
      title: '库存调整 - 列表'
    },
  },
  {
    path: '/warehouse/business/add',
    name: 'businessAdd',
    component: BusinessAdd,
    meta: {
      requireAuth: true,
      title: '库存调整 - '
    },
  },
  {
    path: '/warehouse/business/detail',
    name: 'BusinessDetail',
    component: BusinessDetail,
    meta: {
      requireAuth: true,
      title: '库存调整 - 详情 '
    },
  },
  {
    path: '/warehouse/query',
    name: 'query',
    component: Query,
    meta: {
      requireAuth: true,
      title: '仓库查询'
    },
  },
  {
    path: '/warehouse/query/detail',
    name: 'queryDetail',
    component: QueryDetail,
    meta: {
      requireAuth: true,
      title: '出入库明细查询'
    }
  },
  {
    path: '/warehouse/query/summary',
    name: 'querySummary',
    component: QuerySummary,
    meta: {
      requireAuth: true,
      title: '出入库汇总查询'
    }
  },
  {
    path: '/warehouse/query/inventory',
    name: 'queryInventory',
    component: QueryInventory,
    meta: {
      requireAuth: true,
      title: '库存查询'
    }
  },
  {
    path: '/warehouse/inventory/statement',
    name: 'statement',
    component: Statement,
    meta: {
      requireAuth: true,
      title: '盘点报表'
    }
  },
  {
    path: '/warehouse/purchase/adjustment',
    name: '成本调价单',
    component: Adjustment,
    meta: {
      requireAuth: true,
      title: '成本调价单'
    }
  },
  {
    path: '/warehouse/purchase/adjustmentAdd',
    name: '成本调价单新增',
    component: AdjustmentAdd,
    meta: {
      requireAuth: true,
      title: '成本调价单'
    }
  },
  {
    path: '/warehouse/purchase/adjustment/detail',
    name: '成本调价单详情',
    component: AdjustmentDetail,
    meta: {
      requireAuth: true,
      title: '成本调价单'
    }
  },
  {
    path: '/warehouse/query/purchase',
    name: '成本调价查询',
    component: purchaseQuery,
    meta: {
      requireAuth: true,
      title: '成本调价查询'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/warehouse.route.js